import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { Skeleton } from "@/components/ui/skeleton";
import { PrayerTimeRow } from "@/components/PrayerTimeRow";
import type { PrayerTimes, PrayerName } from "@/types/prayer";

interface Props {
  times: PrayerTimes | null;
  nextPrayer: PrayerName | null;
  loading: boolean;
}

const PRAYER_ORDER: PrayerName[] = [
  "Fajr",
  "Sunrise",
  "Dhuhr",
  "Asr",
  "Maghrib",
  "Isha",
];

export function PrayerTimesCard({ times, nextPrayer, loading }: Props) {
  return (
    <Card>
      <CardHeader className="pb-3">
        <CardTitle className="text-lg">Prayer Times</CardTitle>
      </CardHeader>
      <CardContent className="space-y-1 px-4">
        {PRAYER_ORDER.map((name, i) => (
          <div key={name}>
            {loading ? (
              <Skeleton className="h-10 w-full" />
            ) : (
              <PrayerTimeRow
                name={name}
                time={times?.[name] ?? "--:--"}
                isNext={name === nextPrayer}
                isSecondary={name === "Sunrise"}
                dimmed={!times}
              />
            )}
            {i < PRAYER_ORDER.length - 1 && <Separator />}
          </div>
        ))}
      </CardContent>
    </Card>
  );
}
